import { forwardRef } from 'react';
import * as React from 'react';
import { InputContainerWithInlineLabel } from './InputContainerWithInlineLabel';
import classNames from 'classnames';

interface XplNumberInputWithLabelProps {
  error?: string;
  id?: string;
  label?: string;
  currency?: string;
  inlinelabel?: string;
}

const XplNumberInputWithLabel: React.ForwardRefRenderFunction<
  HTMLInputElement,
  XplNumberInputWithLabelProps
> = (props, ref) => {
  const { error, label, currency, id, inlinelabel } = props;

  return (
    <div
      className={classNames(
        `font-sans text-left flex-col justify-center items-center max-w-[200px]`,
        {
          'h-20 mt-2': label,
          'pb-4': !label,
          'mt-0 pb-0': !label && error,
        },
      )}
    >
      {label && (
        <p className='text-sm font-normal leading-3 text-left text-gray-500'>
          {label}
        </p>
      )}

      <InputContainerWithInlineLabel inlineLabel={currency}>
        <input
          ref={ref}
          key={id}
          type='number'
          step='0.01'
          min={0}
          className='w-full h-full px-2 appearance-none border-0 focus:outline-none focus:ring-0 rounded-l-md'
          {...props}
        />
        <div className='h-full flex items-center justify-center bg-gray-100 border-l border-gray-300 rounded-r-md p-3'>
          <p className='text-sm'>{inlinelabel}</p>
        </div>
      </InputContainerWithInlineLabel>
      {error && <p className='text-red-500 text-xs'>{error}</p>}
    </div>
  );
};

export default forwardRef(XplNumberInputWithLabel);
